import { createContext, useContext, useEffect, useState } from 'react';

const FormReadOnlyContext = createContext(false);
export const FormReadOnlyProvider = FormReadOnlyContext.Provider;
export const useFormReadOnly = () => useContext(FormReadOnlyContext);

/** Gates CSS transitions to the read-only toggle, not unrelated changes such as combobox chips. */
export function useIsTogglingReadOnly(durationMs = 250): boolean {
	const formReadOnly = useFormReadOnly();
	const [isToggling, setIsToggling] = useState(false);
	const [prev, setPrev] = useState(formReadOnly);
	if (prev !== formReadOnly) {
		setPrev(formReadOnly);
		setIsToggling(true);
	}
	useEffect(() => {
		if (!isToggling) return;
		const t = setTimeout(() => setIsToggling(false), durationMs);
		return () => clearTimeout(t);
	}, [isToggling, durationMs]);
	return isToggling;
}
